// ============================================================
// Role Access Service — Super Admin
// ============================================================

import { roleAccessApi } from '@/api/super-admin/roleAccess.api';

export const roleAccessService = {
  getSchoolRoles: async (schoolId) => {
    const res = await roleAccessApi.getSchoolRoles(schoolId);
    return Array.isArray(res) ? res : res?.roles || res?.data || [];
  },

  getRoleAccess: async (schoolId, roleId) => {
    const res = await roleAccessApi.getRoleAccess(schoolId, roleId);
    return res;
  },

  updateRoleAccess: async (schoolId, roleId, modulesPayload) => {
    const res = await roleAccessApi.updateRoleAccess(schoolId, roleId, modulesPayload);
    return res;
  },
};
